import { render, staticRenderFns } from "./SignupForm.vue?vue&type=template&id=cdbfa04a&scoped=true"
import script from "./SignupForm.vue?vue&type=script&lang=ts"
export * from "./SignupForm.vue?vue&type=script&lang=ts"
import style0 from "./SignupForm.vue?vue&type=style&index=0&id=cdbfa04a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbfa04a",
  null
  
)

export default component.exports